import { createSlice } from "@reduxjs/toolkit";

// prevent everytime login
const initialState = {
  heading: [],
  heading: [],
  hypoglycemia: "",
  bloodSugar: {},
  calculatedate: [],
  recordDate: "",
  pageStatusData: [],
  pageStatus: {},
  flage: 0,
  date: null,
  visitDate: null,
};

const componentSlice = createSlice({
  name: "componentReducer",
  initialState,
  reducers: {
    setHypoComponent: (state, action) => {
      state.hypoglycemia = action.payload;
    },
    setBloodSugarComponent: (state, action) => {
      state.bloodSugar = action.payload;
    },

    setCalculateDate: (state, action) => {
      state.calculatedate = [...action.payload];
    },

    setPageId: (state, action) => {
      state.pageStatus = action.payload;
    },
    setSelectedRecordDate: (state, action) => {
      state.recordDate = action.payload;
    },
    setHeading: (state, action) => {
      state.heading = [...action.payload];
    },
    setPageStausData: (state, action) => {
      state.pageStatusData = [...action.payload];
    },
    setFlage: (state, action) => {
      state.flage = action.payload;
    },
    setClickableDate: (state, action) => {
      state.date = action.payload;
    },
    selectedVisitDate: (state, action) => {
      state.visitDate = action.payload;
    },
  },
});

export const {
  setHypoComponent,
  setBloodSugarComponent,
  setCalculateDate,
  setPageId,
  setSelectedRecordDate,
  setHeading,
  setPageStausData,
  setFlage,
  setClickableDate,
  selectedVisitDate,
} = componentSlice.actions;
export default componentSlice.reducer;
